<template>
  <div class="modal">
    <h3>{{ reservation?.id ? 'Edit' : 'Create' }} Reservation</h3>

    <form @submit.prevent="handleSubmit">
      <input v-model="form.start_date" type="date" required />
      <input v-model="form.end_date" type="date" required />

      <select v-model="form.project_type" required>
        <option value="internal">Internal</option>
        <option value="external">External</option>
      </select>

      <input v-model="form.start_time" type="time" required />
      <input v-model="form.end_time" type="time" required />

      <input v-model="form.remarks" placeholder="Remarks (optional)" />

      <input
        v-model.number="form.number_of_persons"
        type="number"
        min="1"
        required
      />

      <button type="submit">Save</button>
      <button @click.prevent="$emit('close')">Cancel</button>
    </form>
  </div>
</template>

<script setup>
import { reactive, watch, defineProps, defineEmits } from 'vue'
import { createReservation, updateReservation } from '@/services/trainingReservations'

const props = defineProps({
  reservation: Object
})

const emit = defineEmits(['close', 'saved'])

const defaultForm = () => ({
  start_date: '',
  end_date: '',
  project_type: 'internal',
  start_time: '',
  end_time: '',
  remarks: '',
  number_of_persons: 1
})

const form = reactive(defaultForm())

watch(
  () => props.reservation,
  (val) => {
    Object.assign(form, defaultForm())

    if (val) {
      Object.assign(form, {
        start_date: val.start_date || '',
        end_date: val.end_date || '',
        project_type: val.project_type || 'internal',
        start_time: (val.start_time || '').slice(0, 5),
        end_time: (val.end_time || '').slice(0, 5),
        remarks: val.remarks || '',
        number_of_persons: val.number_of_persons || 1
      })
    }
  },
  { immediate: true }
)

const handleSubmit = async () => {
  try {
    if (props.reservation?.id) {
      await updateReservation(props.reservation.id, { ...form })
    } else {
      await createReservation({ ...form })
    }

    emit('saved')
    emit('close')
  } catch (error) {
    alert(error.response?.data?.message || error.message)
  }
}
</script>